window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-impressions:not(.initialized)').forEach(impressions => {
    const content = impressions.querySelector('.product-impressions-content');
    let more = false;

    content.childNodes.forEach(firstChild => {
      if (firstChild.childNodes.length > 0) {
        firstChild.childNodes.forEach(child => {
          const html = child.innerHTML;

          if (html) {
            const keyword = '[more]';
            const index = html.indexOf(keyword);

            if (more) {
              child.classList.add('product-impressions-content-more');
            } else if (index > -1) {
              child.innerHTML = html.substring(0, index) + '<span class="product-impressions-content-more">' + html.substring(index + keyword.length) + '</span>';
              more = true;
            }
          }
        });
      }
    });

    if (more) {
      impressions.classList.add('has-more');
    }

    impressions.querySelector('.product-impressions-more').addEventListener('click', e => {
      e.preventDefault();

      impressions.querySelector('.product-impressions-more').remove();
      impressions.querySelectorAll('.product-impressions-content-more').forEach(div => div.classList.remove('product-impressions-content-more'));
    });

    impressions.classList.add('initialized');
  });
})